import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isArtistRole } from '../../types/chat';
import { FOOTER_COPYRIGHT, SITE_TAGLINE, SUPPORT_EMAIL } from '../../config/site';
import './Footer.css';

const Footer: React.FC = () => {
  const { authState } = useAuth();
  const user = authState.user;
  const canChat = !!user && isArtistRole(user.role);
  const canUpload = user?.role === 'producer' || user?.role === 'producer_rapper';

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__inner container-padding">
        <div className="site-footer__grid">
          <div className="site-footer__brand">
            <Link to={user ? '/home' : '/'} className="site-footer__logo">
              DHH Collab
            </Link>
            <p className="site-footer__tagline">{SITE_TAGLINE}</p>
          </div>

          <nav className="site-footer__col" aria-label="Explore">
            <h2 className="site-footer__heading">Explore</h2>
            <ul className="site-footer__links">
              {user ? (
                <>
                  <li>
                    <Link to="/home" className="site-footer__link">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/cypher" className="site-footer__link">
                      Cypher Challenge
                    </Link>
                  </li>
                  <li>
                    <Link to="/search" className="site-footer__link">
                      Find Artists
                    </Link>
                  </li>
                  {canChat && (
                    <li>
                      <Link to="/messages" className="site-footer__link">
                        Messages
                      </Link>
                    </li>
                  )}
                  {canUpload && (
                    <li>
                      <Link to="/upload" className="site-footer__link">
                        Upload Beat
                      </Link>
                    </li>
                  )}
                </>
              ) : (
                <>
                  <li>
                    <Link to="/" className="site-footer__link">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/signup" className="site-footer__link">
                      Create an account
                    </Link>
                  </li>
                  <li>
                    <Link to="/login" className="site-footer__link">
                      Login
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </nav>

          <nav className="site-footer__col" aria-label="Support">
            <h2 className="site-footer__heading">Support</h2>
            <ul className="site-footer__links">
              <li>
                <Link to="/faq" className="site-footer__link">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="site-footer__link">
                  Contact Us
                </Link>
              </li>
              <li>
                <a href={`mailto:${SUPPORT_EMAIL}`} className="site-footer__link">
                  {SUPPORT_EMAIL}
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="site-footer__bottom">
          <p className="site-footer__text">{FOOTER_COPYRIGHT}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
